import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
import React from "react";
import MaskedInput from "react-text-mask";
import { createNumberMask } from "./createNumberMask-dep";
import { formatNumberIntl, unformat } from "@ajayvikas/common-utils";
const breakPercent = (value) => {
    if (!value)
        return [undefined, ""];
    if (typeof value === "number")
        return [value.toString(), ""];
    let numericPart;
    let percentPart;
    const percentMatches = Array.from(value.matchAll(/%/g));
    if (percentMatches.length > 0) {
        numericPart = value.slice(0, percentMatches[0].index);
        percentPart = "%";
    }
    else {
        numericPart = value;
        percentPart = "";
    }
    if (numericPart)
        return [numericPart, percentPart];
    return [undefined, percentPart];
};
const getFormattedValue = (value, maxDecimals, minDecimals) => {
    const [numericPart, percent] = breakPercent(value);
    const number = Number(numericPart);
    if (isNaN(number))
        return "";
    const formattedValue = formatNumberIntl(number, maxDecimals, minDecimals);
    if (formattedValue)
        return formattedValue + percent;
    else
        return "";
};
const getNumericValue = (value) => {
    if (!value)
        return undefined;
    const [numericPart, percent] = breakPercent(value);
    if (!numericPart)
        return undefined;
    const floatValue = unformat(numericPart);
    if (floatValue === undefined)
        return undefined;
    return floatValue + percent;
};
export const NumericPercentInput = React.forwardRef((props, forwardRef) => {
    const { value, onChange: propsOnChange, onBlur: propsOnBlur, __fireOnChangeOnUnmount, maxDecimals = 2, className, minDecimals = 0, currencySymbol, allowNegative = false, maxDecimals: decimalLimit = 2, showMask, allowPercent = false, onKeyPress: onKeyPressProp, onKeyDown, ...rest } = props;
    const [stateValue, setStateValue] = React.useState(() => getFormattedValue(value, maxDecimals, minDecimals));
    const stateValueRef = React.useRef(stateValue);
    React.useEffect(() => { stateValueRef.current = stateValue; }, [stateValue]);
    React.useEffect(() => {
        const numericValue = getNumericValue(stateValueRef.current);
        if (value !== numericValue) {
            setStateValue(getFormattedValue(value, maxDecimals, minDecimals));
        }
    }, [maxDecimals, minDecimals, value]);
    const [numberMask, pipe] = React.useMemo(() => createNumberMask({
        decimalLimit: maxDecimals,
        allowNegative: allowNegative || false,
        allowPercent: allowPercent,
        enformceDecimalLimit: true,
        currencySymbol: currencySymbol || ""
    }), [maxDecimals, allowNegative, allowPercent, currencySymbol]);
    const onInput = (e) => {
        const inputValue = e.target.value;
        if (inputValue === stateValue)
            return;
        setStateValue(inputValue);
        // const numericValue = getNumericValue(inputValue);
        // if (propsOnInput && numericValue !== value) {
        //     propsOnInput(numericValue);
        // }
    };
    const onChange = (e) => {
        // if (!stateValue && defaultValue !== undefined) {
        //     const dv = typeof defaultValue === "function" ? defaultValue() : defaultValue;
        //     setStateValue(getFormattedValue(dv, maxDecimals, minDecimals));
        //     if (propsOnChange && dv !== value) {
        //         propsOnChange(dv);
        //     }
        //     return;
        // }
        const numericValue = getNumericValue(stateValue);
        const formattedValue = getFormattedValue(numericValue, maxDecimals, minDecimals);
        //e.g. if user types .0 and tabs, the value should change to 0.
        //another example: if user types % and tabs, the value should change to blank.
        // if (formattedValue !== stateValue) setStateValue(formattedValue);
        if (getFormattedValue(value, maxDecimals, minDecimals) !== formattedValue) {
            propsOnChange?.(numericValue);
        }
    };
    const onBlur = (e) => {
        onChange(e);
        propsOnBlur?.(e);
    };
    const setRef = React.useCallback((ref) => {
        if (forwardRef) {
            if (typeof forwardRef === "function") {
                forwardRef(ref?.inputElement);
            }
            else {
                forwardRef.current = ref?.inputElement;
            }
        }
    }, [forwardRef]);
    const charTest = React.useMemo(() => {
        const allowDecimal = decimalLimit !== 0;
        const decimalSymbol = ".";
        const regExString = `[\\d${allowNegative ? "-" : ""}${allowDecimal ? decimalSymbol : ""}${allowPercent ? "%" : ""}]`;
        return new RegExp(regExString);
    }, [allowNegative, allowPercent, decimalLimit]);
    const onKeyPress = (e) => {
        if (!charTest.test(e.key)) {
            e.preventDefault();
        }
        onKeyPressProp?.(e);
    };
    const onInputKeyDown = (e) => {
        onKeyDown?.(e);
        if (e.defaultPrevented) {
            onChange();
        }
    };
    return _jsx(MaskedInput, { ref: setRef, ...rest, mask: numberMask, onKeyPress: onKeyPress, className: className, pipe: pipe, showMask: true, value: stateValue, onChange: onInput, onKeyDown: __fireOnChangeOnUnmount ? onInputKeyDown : onKeyDown, onBlur: onBlur });
});
